import React  from 'react';  
import minusImg from 'images/round_minus_btn-19x19.png'; 
import plusImg from 'images/round_plus_btn-19x19.png';
import { CreateSection, TitleWrapper, TitleInput, PreTitleTxt, PostTitleTxt, DescriptionWrapper, Description, 
        DescriptionCount, CapacityWrapper, CapacityLeft, CapacityRight, CapacityBtn, CapacityBtnImg, CapacityCnt } from './style'
export default function MatchingRoomForm({onChange, onIncreaseCapacity, title, description, capacity}) {
  return (
      <CreateSection>
        <TitleWrapper>
          <PreTitleTxt>같이</PreTitleTxt><TitleInput type='text' value={title} placeholder={`미라클모닝`} onChange={(e)=>{if(onChange) onChange({title: e.target.value})}}/><PostTitleTxt>하실분~?</PostTitleTxt>
        </TitleWrapper>
        <DescriptionWrapper>
          <Description value={(description)?description:''} onChange={(e)=>{if(onChange) onChange({description: e.target.value})}} rows="8" maxlength="150" placeholder={`예시 : 
같이 하고 싶은 자기계발 활동을 적어주세요!

요즘 비즈니스 공부 필요성을 느껴서 공부하려고
하는데 같이 공부 하실분 있으시면 채팅 들어오세요!`}></Description>
          <DescriptionCount>{(description)? `${description.length}`:'0'}/150</DescriptionCount>
        </DescriptionWrapper>
        <CapacityWrapper>
          <CapacityLeft>참여 인원 수</CapacityLeft>
          <CapacityRight>
            <CapacityBtn onClick={(e)=>{if(onChange) onChange({capacity: (capacity-1)})}}><CapacityBtnImg src={minusImg}/></CapacityBtn>
            <CapacityCnt>{(capacity)?capacity:0}</CapacityCnt>
            <CapacityBtn onClick={(e)=>{if(onChange) onChange({capacity: (capacity+1)})}}><CapacityBtnImg src={plusImg} /></CapacityBtn>
          </CapacityRight>
        </CapacityWrapper>
      </CreateSection>
  );
}
